var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatchSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 58",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECF0F1"
    },
    cx: 29,
    cy: 29,
    r: 29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545E73"
    },
    d: "M29,4c13.785,0,25,11.215,25,25S42.785,54,29,54S4,42.785,4,29S15.215,4,29,4 M29,0 C12.984,0,0,12.984,0,29s12.984,29,29,29s29-12.984,29-29S45.016,0,29,0L29,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M29,5.879c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1 C30,6.326,29.552,5.879,29,5.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M29,48.879c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1 C30,49.326,29.552,48.879,29,48.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M51,27.879h-1c-0.552,0-1,0.447-1,1s0.448,1,1,1h1c0.552,0,1-0.447,1-1S51.552,27.879,51,27.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M8,27.879H7c-0.552,0-1,0.447-1,1s0.448,1,1,1h1c0.552,0,1-0.447,1-1S8.552,27.879,8,27.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M43.849,12.615l-0.707,0.707c-0.391,0.391-0.391,1.023,0,1.414 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l0.707-0.707c0.391-0.391,0.391-1.023,0-1.414 S44.24,12.224,43.849,12.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M13.444,43.021l-0.707,0.707c-0.391,0.391-0.391,1.023,0,1.414 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l0.707-0.707c0.391-0.391,0.391-1.023,0-1.414 S13.834,42.631,13.444,43.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M44.556,43.021c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l0.707,0.707 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L44.556,43.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M14.151,12.615c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l0.707,0.707 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L14.151,12.615z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545E73"
    },
    d: "M26,29.879h-8c-0.552,0-1-0.447-1-1s0.448-1,1-1h8c0.552,0,1,0.447,1,1S26.552,29.879,26,29.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545E73"
    },
    d: "M29,26.879c-0.552,0-1-0.447-1-1v-11c0-0.553,0.448-1,1-1s1,0.447,1,1v11 C30,26.432,29.552,26.879,29,26.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545E73"
    },
    d: "M29,32.879c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S31.206,32.879,29,32.879z M29,26.879 c-1.103,0-2,0.897-2,2s0.897,2,2,2s2-0.897,2-2S30.103,26.879,29,26.879z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC41A"
    },
    d: "M55.15,58H31.46c-0.955,0-1.55-1.036-1.069-1.861l11.845-20.306c0.478-0.819,1.66-0.819,2.138,0 l11.845,20.306C56.7,56.964,56.105,58,55.15,58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M43.39,51c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1s1,0.448,1,1v8 C44.39,50.552,43.942,51,43.39,51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M43.39,55c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.38-0.37,1.04-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C43.91,54.89,43.66,55,43.39,55z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchSvgrepoCom);
export default __webpack_public_path__ + "static/media/stopwatch-svgrepo-com.89270ee17b992ff3bb790068c8c72257.svg";
export { ForwardRef as ReactComponent };